<template>
  <div class="container-fluid">

    <header class="page header">
      <div class="content">
        <h1 class="display-4 mb-0 mt-4">Davčna blagajna</h1>
        <p class="lead text-muted">{{property.name}}</p>
      </div>
    </header>
    <router-view id="list" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'CashRegister',
  data: () => ({
    title: '',
    property: ''
  }),
  created(){
    const slug = this.$route.params.property;
    this.property = this.$store.state.host.properties.find(p => p.slug == slug);
  }
};
</script>
